<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T15:08:56+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Usrermanuals page
@Last modified by:   tom
@Last modified time: 2019-06-12T17:26:05+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>
  <section id="specifications">

    <!-- title block -->
    <h1 class="text-secondary" v-html="$t('puck.specifications.title')"/>

    <b-row>
      <b-col
        v-for="f in 2"
        :key="f">
        <lzimg
          id="workflowimg"
          :src="assetUrl('img/puck/' + $t(`puck.specifications.images.${f}._img`))"
          :modal-header="$t(`puck.specifications.images.${f}.title`)"
          fluid
          width="1200"
          height="600"
          zoom-modal/>
      </b-col>
    </b-row>

    <b-list-group class="mt-2">
      <b-list-group-item v-for="f in 10" :key="f">
        <small>
          <b v-html="$t(`puck.specifications.${f}.label`)" />&nbsp;-&nbsp;
          <span v-html="$t(`puck.specifications.${f}.payload`)"/>
        </small>
      </b-list-group-item>
      <b-list-group-item>
        <small class="text-primary" v-html="$t(`puck.specifications.disclaimer`)"/>
      </b-list-group-item>
    </b-list-group>

  </section>
</template>

<script>
// import Vue from 'vue'

export default {
  name: 'PuckSpecs'
}
</script>

<style lang="scss" scoped>

</style>
